import React from 'react'
import { Carousel, Container, Row, Col, ListGroup } from "react-bootstrap";
import { useState } from "react";
import "./Slider.css"

const Slider = ({ slides }) => {
    const [activeIndex, setActiveIndex] = useState(0);

    const decodeHtml = (html) => {
        const doc = new DOMParser().parseFromString(html, "text/html");
        return doc.documentElement.textContent;
    };

    return (
        <Container fluid className='panel panel-body'>
            <Row className='h-100 slider'>
                <Col md={7} className='slides'>
                    <Carousel activeIndex={activeIndex} onSelect={(selectedIndex) => setActiveIndex(selectedIndex)}>
                        {slides.map((slide) => (
                            <Carousel.Item key={slide.globalAssetId}>
                                <img className="d-block img" src={slide.coverUrl} alt={slide.title} />
                            </Carousel.Item>
                        ))}
                    </Carousel>
                </Col>
                <Col md={5} className='slider-menu'>
                    <ListGroup variant="flush" className='h-100'>
                        {slides.map((slide, index) => (
                            <ListGroup.Item
                                className='slider-menu-item'
                                key={slide.globalAssetId}
                                onClick={() => setActiveIndex(index)}
                                active={index === activeIndex}
                            >
                                <h4>{slide.title}</h4>
                                <h6 dangerouslySetInnerHTML={{ __html: decodeHtml(slide.description) }} />
                            </ListGroup.Item>
                        ))}
                    </ListGroup>
                </Col>
            </Row>
        </Container >
    )
}

export default Slider